import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import iconLinkedin from '../../../assets/icon-linkedin-fill.svg';
import iconEmail from '../../../assets/icon-email-outline.svg';
import iconDomain from '../../../assets/icon-domain.svg';
import Button from '../../molecules/Button';
import { ModalStyles } from './InfoSection.styles';

const ConnectAccountModal = ({ onClose }) => {
  const navigate = useNavigate();
  const [selectedSource, setSelectedSource] = useState('linkedin');

  function handleSubmit(e) {
    e.preventDefault();
    if (!selectedSource) return;

    let activeTab = 'domain';

    if (selectedSource === 'linkedin') {
      activeTab = 'linkedin';
    } else if (selectedSource === 'email') {
      activeTab = 'single';
    } else if (selectedSource === 'domain') {
      activeTab = 'domain';
    }

    sessionStorage.setItem('emailAccountActiveTab', activeTab);

    navigate('/email-accounts', { state: { activeTab } });
    if (onClose) onClose();
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <ModalStyles>
          <div className="holder">
            <div className="header">
              <strong className="title">Select Account Type</strong>
              <p>Name your campaign and select where your leads will come from.</p>
            </div>

            <div className="item-wrap">
              <label htmlFor="linkedin" className="radio-custom">
                <input
                  id="linkedin"
                  type="radio"
                  name="account-source"
                  value="linkedin"
                  checked={selectedSource === 'linkedin'}
                  onChange={e => setSelectedSource(e.target.value)}
                />
                <span className="radio-text">
                  <img src={iconLinkedin} width="39" alt="linkedin" />
                  Linkedin
                </span>
              </label>
              <label htmlFor="email" className="radio-custom">
                <input
                  id="email"
                  type="radio"
                  name="account-source"
                  value="email"
                  checked={selectedSource === 'email'}
                  onChange={e => setSelectedSource(e.target.value)}
                />
                <span className="radio-text">
                  <img src={iconEmail} width="39" alt="email" />
                  Email
                </span>
              </label>
              <label htmlFor="domain" className="radio-custom">
                <input
                  id="domain"
                  type="radio"
                  name="account-source"
                  value="domain"
                  checked={selectedSource === 'domain'}
                  onChange={e => setSelectedSource(e.target.value)}
                />
                <span className="radio-text">
                  <img src={iconDomain} width="39" alt="domain" />
                  Domain
                </span>
              </label>
            </div>
          </div>
          <div className="btn-holder">
            <Button newStyle rounded variant="outline" width="155px" onClick={onClose}>
              Cancel
            </Button>
            <Button newStyle rounded variant="darkBlue" type="submit" width="155px">
              Next
            </Button>
          </div>
        </ModalStyles>
      </form>
    </>
  );
};

export default ConnectAccountModal;
